var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 0C1.00736 0 0 1.00736 0 2.25V18L3.9375 15.75L7.875 18L11.8125 15.75L15.75 18V2.25C15.75 1.00736 14.7427 0 13.5 0H2.25ZM5.0625 3.375C4.13052 3.375 3.375 4.13052 3.375 5.0625C3.375 5.99448 4.13052 6.75 5.0625 6.75C5.99448 6.75 6.75 5.99448 6.75 5.0625C6.75 4.13052 5.99448 3.375 5.0625 3.375ZM12.0455 3.7045C11.6062 3.26517 10.8938 3.26517 10.4545 3.7045L3.7045 10.4545C3.26517 10.8938 3.26517 11.6062 3.7045 12.0455C4.14385 12.4848 4.85615 12.4848 5.2955 12.0455L12.0455 5.2955C12.4848 4.85615 12.4848 4.14385 12.0455 3.7045ZM10.6875 9C9.75555 9 9 9.75555 9 10.6875C9 11.6194 9.75555 12.375 10.6875 12.375C11.6194 12.375 12.375 11.6194 12.375 10.6875C12.375 9.75555 11.6194 9 10.6875 9Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/Tax.7da25661.svg";
export { ForwardRef as ReactComponent };